import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useKaleadicalStore = defineStore('kaleadical', () => {
    const all = ref({ data: [] });
    const active = ref(null);

    const kaleadical = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/kaleadicals', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/kaleadicals', params);
    };

    const update = (params) => {
        return axios.patch('/api/v1/kaleadicals/' + params.hash, params);
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/kaleadicals/' + params.hash);
    };

    const incrementItem = (params) => {
        return axios.post('/api/v1/kaleadicals/' + params.hash + '/increment/' + params.itemHash);
    };

    const generateAIShape = (prompt) => {
        return axios.post('/api/v1/kaleadicals/generate-shape', { prompt });
    };

    const uploadImage = (params, payload) => {
        return axios.post(`/api/v1/kaleadicals/${params.hash}/upload`, payload);
    };

    const updateKaleadicalScale = (params, payload) => {
        return axios.post(`/api/v1/kaleadicals/${params.hash}/update-scale`, payload);
    };

    return {
        all,
        kaleadical,
        active,
        reset,
        search,
        store,
        update,
        destroy,
        incrementItem,
        generateAIShape,
        uploadImage,
        updateKaleadicalScale
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useKaleadicalStore, import.meta.hot));
}
